var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 12L3.04299 11.063C4.66588 9.93078 6.90234 10.3535 8 12V12V12C9.09766 10.3535 11.3341 9.93078 12.957 11.063L14.3 12H15H1H1.7Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12L3 6L4.23398 5.58867C5.36474 5.21175 6.59893 5.29946 7.66502 5.83251V5.83251C7.8759 5.93795 8.1241 5.93795 8.33498 5.83251V5.83251C9.40107 5.29946 10.6353 5.21175 11.766 5.58867L13 6L14.5 12",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBook);
export default __webpack_public_path__ + "static/media/OpenBook.f3acb0c1c4d8bdc24ae57b2a56111533.svg";
export { ForwardRef as ReactComponent };